import ModelBase, {IModelBase} from '@/models/ModelBase'
import Tag, { ITag } from '@/models/Tag'
import { KeyPair } from '@/types/KeyPair'

export interface ICareer extends IModelBase {
  user_id?: number
  tag?: ITag
  years?: number
}

export default class Career extends ModelBase {
  user_id?: number
  tag?: Tag
  years?: number

  constructor(defaults?: ICareer) {
    super(defaults)
    if (defaults) {
      this.user_id = defaults.user_id
      this.years = defaults.years
      this.tag = defaults.tag ? new Tag(defaults.tag) : undefined
    }
  }

  toParams(): KeyPair {
    return {
      user_id: this.user_id,
      tag_id: this.tag.id,
      years: this.years
    }
  }
}
